import { useAuth } from '@/common/contexts/AuthContext';

const SortOptions = () => {
  const { isShowNetPrice } = useAuth();

  const PRODUCT_LIST_SORT = [
    {
      code: 'name',
      direction: null,
      label: 'common:messages:sort.item',
      sortable: false,
    },
    {
      code: 'sku',
      direction: null,
      label: 'Code',
      sortable: false,
    },
    {
      code: 'manufacturer_sku',
      direction: null,
      label: 'Ref. fabricant',
      sortable: false,
    },
    {
      code: 'favorite',
      direction: null,
      label: 'Favori',
      sortable: false,
    },
    {
      code: 'customer_price',
      direction: null,
      label: 'Prix net H.T.',
      sortable: false,
    },
    {
      code: 'public_price',
      direction: null,
      label: 'Prix public H.T.',
      sortable: false,
    },
    {
      code: 'stock',
      direction: null,
      label: 'common:messages:sort.stock',
      sortable: false,
    },
    {
      code: 'quantity',
      direction: null,
      label: 'Quantité',
      sortable: false,
    },
  ];

  const ORDERS_LIST_SORT = [
    {
      label: 'common:messages:sort.date',
      code: 'created_at',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.number',
      code: 'number',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.reference',
      code: 'reference',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.status',
      code: 'status',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.worksite',
      code: 'worksite',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.amount_total_left',
      code: 'amount_total_left',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.amount_total_raw',
      code: 'amount_total_raw',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.origin',
      code: 'origin',
      direction: null,
      sortable: false,
    },
  ];

  const ORDER_ITEMS_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'article',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité commandée',
      code: 'ordered-quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité livrable',
      code: 'deliverable-quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité livrée',
      code: 'delivered-quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Délai',
      code: 'delay',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité pour la sélection',
      code: 'selected-quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix net H.T.',
      code: 'customer-price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'customer_total',
      direction: null,
      sortable: false,
    },
  ];

  const CART_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'name',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix net H.T.',
      code: 'customer_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total',
      direction: null,
      sortable: false,
    },
  ];

  const WORKSITES_LIST_SORT = [
    {
      label: 'Date',
      code: 'creation_date',
      direction: null,
      sortable: false,
    },
    {
      label: 'Code',
      code: 'code',
      direction: null,
      sortable: false,
    },
    {
      label: 'Référence',
      code: 'label',
      direction: null,
      sortable: false,
    },
    {
      label: 'Nom',
      code: 'address_name',
      direction: null,
      sortable: false,
    },
    {
      label: 'Ville',
      code: 'address_city',
      direction: null,
      sortable: false,
    },
    {
      label: null,
      code: 'details',
      direction: null,
      sortable: false,
    },
  ];

  const INVOICE_LIST_SORT = [
    {
      label: 'Date',
      code: 'date',
      direction: null,
      sortable: false,
    },
    {
      label: 'N° Facture',
      code: 'id',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_raw',
      direction: null,
      sortable: false,
    },
  ];

  const TOP_PRODUCTS_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'article',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
    {
      label: isShowNetPrice ? 'Prix net H.T.' : 'Prix public',
      code: 'customer_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantite',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_raw',
      direction: null,
      sortable: false,
    },
  ];

  const QUOTE_DEFAULT_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'article',
      direction: null,
      sortable: false,
    },
    {
      label: null,
      code: 'image',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix public H.T.',
      code: 'public_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix net H.T.',
      code: 'customer_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité restante',
      code: 'remaining_quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_raw',
      direction: null,
      sortable: false,
    },
  ];

  const QUOTE_DRAFT_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'article',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix net H.T.',
      code: 'customer_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantite',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_raw',
      direction: null,
      sortable: false,
    },
  ];

  const QUOTE_INSTALLER_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'article',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix net H.T.',
      code: 'customer_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix public H.T.',
      code: 'net_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Coeff.',
      code: 'coefficient',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix unitaire H.T.',
      code: 'unit_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_raw',
      direction: null,
      sortable: false,
    },
    {
      label: 'TVA',
      code: 'vat',
      direction: null,
      sortable: false,
    },
  ];

  const QUOTE_INSTALLER_DETAIL_LIST_SORT = [
    {
      label: 'Articles',
      code: 'name',
      direction: null,
      sortable: false,
    },
    {
      label: null,
      code: 'reference',
      direction: null,
      sortable: false,
    },
    {
      label: 'Prix unitaire H.T.',
      code: 'unit_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Taux de TVA',
      code: 'vat',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant TTC',
      code: 'total_amount',
      direction: null,
      sortable: false,
    },
  ];

  const DOCUMENTS_LIST_SORT = [
    {
      label: 'Date',
      code: 'createdAt',
      direction: null,
      sortable: false,
    },
    {
      label: 'Nom',
      code: 'title',
      direction: null,
      sortable: false,
    },
    {
      label: 'Description',
      code: 'subtitle',
      direction: null,
      sortable: false,
    },
    {
      label: null,
      code: 'link',
      direction: null,
      sortable: false,
    },
  ];

  const WISHLISTS_LIST_SORT = [
    {
      label: 'Date',
      code: 'created_at',
      direction: null,
      sortable: false,
    },
    {
      label: 'Nom',
      code: 'name',
      direction: null,
      sortable: false,
    },
    {
      label: 'Nombre de produits',
      code: 'subtitle',
      direction: null,
      sortable: false,
    },
  ];

  const QUOTES_LIST_SORT = [
    {
      label: 'common:messages:sort.date',
      code: 'created_at',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.number',
      code: 'number',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.reference',
      code: 'reference',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.status',
      code: 'status',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.worksite',
      code: 'worksite',
      direction: null,
      sortable: false,
    },
    {
      // label: 'Type',
      code: 'type',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.origin',
      code: 'origin',
      direction: null,
      sortable: false,
    },
  ];

  const WISHLIST_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'name',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
    {
      label: isShowNetPrice ? 'Prix net H.T.' : 'Prix public',
      code: 'customer_price',
      direction: null,
      sortable: false,
    },
    {
      label: 'Quantité',
      code: 'quantite',
      direction: null,
      sortable: false,
    },
    {
      label: 'Montant H.T.',
      code: 'total_raw',
      direction: null,
      sortable: false,
    },
  ];

  // Local sort

  const PRODUCTS_LIST = [
    {
      code: 'name',
      key: 'name',
      label: 'common:messages:sort.name',
      label_mobile: null,
      sortable: true,
    },
    {
      code: 'sku',
      key: 'sku',
      label: 'common:messages:sort.sku',
      label_mobile: null,
      sortable: true,
    },
    {
      code: 'manufacturer_sku',
      key: 'manufacturer-sku',
      label: 'common:messages:sort.manufacturer_sku',
      label_mobile: null,
      sortable: true,
    },
    {
      code: null,
      key: 'favorite',
      label: 'common:messages:sort.favorite',
      label_mobile: null,
      sortable: false,
    },
    {
      code: 'price_and_stock.price.customer_price',
      key: 'customer-price',
      label: 'common:messages:sort.customer_price',
      label_mobile: null,
      sortable: true,
    },
    {
      code: 'price_and_stock.price.public_price',
      key: 'public-price',
      label: 'common:messages:sort.public_price',
      label_mobile: null,
      sortable: true,
    },
    {
      code: null,
      key: 'stock',
      label: 'common:messages:sort.stock',
      label_mobile: null,
      sortable: false,
    },
    {
      code: null,
      key: 'cart',
      label: 'common:messages:sort.quantity',
      label_mobile: null,
      sortable: false,
    },
  ];

  const PRODUCTS_TABLE = [
    {
      code: null,
      key: 'before',
      label: null,
      label_mobile: null,
      sortable: false,
    },
    {
      code: 'sku',
      key: 'sku',
      label: 'common:messages:sort.sku',
      label_mobile: null,
      sortable: true,
    },
    {
      code: 'name',
      key: 'name',
      label: 'common:messages:sort.name',
      label_mobile: null,
      sortable: true,
    },
    {
      code: 'price_and_stock.price.public_price',
      key: 'public-price',
      label: 'common:messages:sort.public_price',
      label_mobile: 'common:messages:sort.price',
      sortable: true,
    },
    {
      code: 'price_and_stock.price.customer_price',
      key: 'customer-price',
      label: 'common:messages:sort.customer_price',
      label_mobile: null,
      sortable: true,
    },
    {
      code: null,
      key: 'stock',
      label: 'common:messages:sort.stock',
      label_mobile: null,
      sortable: false,
    },
    {
      code: null,
      key: 'favorite',
      label: 'common:messages:sort.favorite',
      label_mobile: null,
      sortable: false,
    },
    {
      code: null,
      key: 'cart',
      label: 'common:messages:sort.quantity',
      label_mobile: null,
      sortable: false,
    },
  ];

  const STOCKS_CHECKOUT_LIST_SORT = [
    {
      label: 'common:messages:sort.item',
      code: 'article',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.stock',
      code: 'stock',
      direction: null,
      sortable: false,
    },
  ];

  const STOCKS_DETAILS_LIST_SORT = [
    {
      label: 'common:messages:sort.warehouse',
      code: 'warehouse',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.quantity',
      code: 'quantity',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.availability',
      code: 'availability',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.bath',
      code: 'bath',
      direction: null,
      sortable: false,
    },
    {
      label: 'common:messages:sort.reel',
      code: 'reel',
      direction: null,
      sortable: false,
    },
  ];

  return {
    PRODUCT_LIST_SORT,
    ORDERS_LIST_SORT,
    ORDER_ITEMS_LIST_SORT,
    WORKSITES_LIST_SORT,
    CART_LIST_SORT,
    INVOICE_LIST_SORT,
    TOP_PRODUCTS_LIST_SORT,
    QUOTE_DEFAULT_LIST_SORT,
    QUOTE_DRAFT_LIST_SORT,
    QUOTE_INSTALLER_LIST_SORT,
    QUOTE_INSTALLER_DETAIL_LIST_SORT,
    DOCUMENTS_LIST_SORT,
    WISHLISTS_LIST_SORT,
    QUOTES_LIST_SORT,
    WISHLIST_LIST_SORT,
    PRODUCTS_LIST,
    PRODUCTS_TABLE,
    STOCKS_CHECKOUT_LIST_SORT,
    STOCKS_DETAILS_LIST_SORT,
  };
};

export default SortOptions;
